import styled from 'styled-components';
import { Banner } from '@lux/banner';

export const StyledBanner = styled(Banner)`
    position: relative;
    z-index: -1;
`;
